// extracted by mini-css-extract-plugin
module.exports = {"wrap":"waveform_wrap__uDNFK","canvas":"waveform_canvas__dxUVs","time":"waveform_time__rXPYr"};